import BaseToast from "./BaseToast.vue"
import { mountComponent } from "./mountComponent"

type BaseToastProps = {
  message?: string
  type?: "success" | "error" | "info"
  timeout?: number
}

const toast_ = (props: BaseToastProps) =>
  mountComponent<BaseToastProps>(BaseToast, {
    props,
  })

export const toast = {
  error: (message: string) =>
    toast_({ message, type: "error" }),
  success: (message: string, timeout?: number) =>
    toast_({ message, type: "success", timeout }),
  info: (message: string) =>
    toast_({ message, type: "info" }),
}
